import Enum from "../../../../../../enums/Enum";

const GaitEnum = new Enum({
        NORMAL_BEDREST_WHEELCHAIR: {name: "Normal/Bed rest/Wheel Chair"},
        WEAK: {name: "Weak"},
        IMPAIRED: {name: "Impaired"},

});

export default GaitEnum;